import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { BASE_URL_DEV } from "../utils/config";

interface LoginData {
  name: string;
  password: string;
}

interface LoginResponse {
  token: string;
  user: {
    id: string;
    name: string;
    email: string;
    category: string;
    role: string;
  };
}

interface UseLoginOptions {
  onError?: (error: string) => void;
}

export const useLogin = (options?: UseLoginOptions) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({
      name,
      password,
    }: LoginData): Promise<LoginResponse> => {
      const response = await fetch(`${BASE_URL_DEV}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name.trim(),
          password: password.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("Invalid credentials");
        }
        throw new Error("An error occurred");
      }

      return data;
    },
    onSuccess: (data) => {
      localStorage.setItem("token", data.token);

      const userData = {
        id: data.user.id,
        name: data.user.name,
        email: data.user.email,
        category: data.user.category,
        role: data.user.role,
      };
      localStorage.setItem("user", JSON.stringify(userData));

      if (data.user.role === "admin") {
        navigate("/admin");
      } else if (data.user.role === "user") {
        navigate("/platform");
      }
    },
    onError: (error: any) => {
      const errorMessage =
        error.message || "An error occurred. Please try again.";
      options?.onError?.(errorMessage);
    },
  });
};